/**
 * LoginPrompt.jsx
 *
 * Reusable component shown when a non-logged-in user tries to
 * access gated content (play video, listen to audio, view image etc.)
 *
 * Usage:
 *   import LoginPrompt from "./LoginPrompt";
 *   const [showPrompt, setShowPrompt] = useState(false);
 *   <LoginPrompt show={showPrompt} onClose={() => setShowPrompt(false)} />
 *
 * Shows as an overlay modal — no redirect, no error page.
 */

import { useNavigate } from "react-router-dom";

const LoginPrompt = ({ show, onClose }) => {
  const navigate = useNavigate();

  if (!show) return null;

  return (
    <>
      {/* Overlay backdrop */}
      <div
        onClick={onClose}
        style={{
          position: "fixed", top: 0, left: 0,
          width: "100vw", height: "100vh",
          background: "rgba(0,0,0,0.45)",
          zIndex: 9998,
          backdropFilter: "blur(2px)",
        }}
      />

      {/* Modal card */}
      <div style={{
        position: "fixed",
        top: "50%", left: "50%",
        transform: "translate(-50%, -50%)",
        background: "#fff",
        borderRadius: 18,
        boxShadow: "0 8px 40px rgba(0,0,0,0.18)",
        padding: "36px 32px",
        zIndex: 9999,
        width: "90%",
        maxWidth: 400,
        textAlign: "center",
      }}>
        {/* Icon */}
        <div style={{
          width: 64, height: 64, borderRadius: "50%",
          background: "#fff5f2",
          border: "2px solid #E34607",
          display: "flex", alignItems: "center", justifyContent: "center",
          margin: "0 auto 20px",
          fontSize: 28,
        }}>
          🔐
        </div>

        {/* Title */}
        <h3 style={{
          fontWeight: 700, fontSize: 22,
          color: "#333", marginBottom: 10,
        }}>
          Please Login to Continue
        </h3>

        {/* Message */}
        <p style={{
          color: "#888", fontSize: 15,
          lineHeight: 1.6, marginBottom: 28,
        }}>
          You need to be logged in to access this content.
          Login is quick and requires no password!
        </p>

        {/* Login button */}
        <button
          onClick={() => navigate("/signin")}
          style={{
            width: "100%", padding: "13px 0",
            background: "#E34607", color: "#fff",
            border: "none", borderRadius: 10,
            fontSize: 16, fontWeight: 600,
            cursor: "pointer", marginBottom: 12,
            transition: "background 0.2s",
          }}
          onMouseEnter={(e) => e.target.style.background = "#d13a06"}
          onMouseLeave={(e) => e.target.style.background = "#E34607"}
        >
          Login with OTP →
        </button>

        {/* Cancel */}
        <button
          onClick={onClose}
          style={{
            width: "100%", padding: "11px 0",
            background: "transparent", color: "#888",
            border: "1px solid #e0e0e0", borderRadius: 10,
            fontSize: 15, cursor: "pointer",
            transition: "all 0.2s",
          }}
          onMouseEnter={(e) => { e.target.style.background = "#f5f5f5"; }}
          onMouseLeave={(e) => { e.target.style.background = "transparent"; }}
        >
          Maybe Later
        </button>
      </div>
    </>
  );
};

export default LoginPrompt;